import IJitRepository from '../domain/IJitRepository';
import { RemarkMapper } from '../infrastructure/mappers/remark.mapper';
import jitRepository from '../infrastructure/repositories/JitRepository';

class EditJitRemarkService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ body }: { body: any }) {
    const dto = RemarkMapper.toEditDTO(body);
    return this._jitRepository.editJitRemark({ body: dto }).then(() => {
      return body;
    });
  }
}

export default new EditJitRemarkService({
  repository: jitRepository
});

export { EditJitRemarkService };
